import React, {Component} from 'react';
import {getLocationLabel} from './locations';

export default class ChatUserResults extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }



  renderCancerCenter(result) {
    if (!result.geolocation) return null;
    let label = getLocationLabel(result.geolocation.cancer_center);
    return (
      <div>
        {label} is {result.geolocation.distance} miles away.
      </div>
    )
  }
  renderResult(result) {
    return (
      <div key={result.trial_id}>
        <h2>{result.summary.headline} - {result.trial_identifier}</h2>
        <a href={result.study_url}>{result.study_url}</a>
        <p>{result.summary.summary}</p>
        {this.renderCancerCenter(result)}
      </div>
    )
  }


  render() {
    let {results} = this.props;
    return (
      <div>
        {results.map(r => this.renderResult(r))}
      </div>
    );
  }
}
